import { HeadphonesIcon as PhosphorHeadphonesIcon } from "@phosphor-icons/react/dist/ssr/Headphones";

import { createAppIcon } from "@/components/createAppIcon";

export const HeadphonesIcon = /* @__PURE__ */ createAppIcon(PhosphorHeadphonesIcon);
